import ClipboardJS from 'clipboard'

const SHARE_FUNCTION_CLASS_PARENT = '.share-function'
const SHARE_COPY_CLASS = '.share-function__share-options__copy'
class ShareFunction {
  constructor() {
    this.parent = document.querySelector(SHARE_FUNCTION_CLASS_PARENT)

    if (!this.parent) return

    this.copyMessage = document.querySelector(SHARE_FUNCTION_CLASS_PARENT + '__message')
    this.mainButton = this.parent.querySelector(SHARE_FUNCTION_CLASS_PARENT + '__main-icon')
    this.copyButton = this.parent.querySelector(SHARE_COPY_CLASS)

    this.copyMessageTimeoutId = undefined

    this.clipboard = new ClipboardJS(this.copyButton)

    this.addListeners()
  }

  addListeners() {
    this.mainButton.addEventListener('click', this.share.bind(this))
    this.copyButton.addEventListener('click', this.copyToClipboard.bind(this))
  }

  share() {
    navigator.canShare ? this.shareMobile() : this.shareDesktop()
  }

  shareMobile() {
    navigator
      .share({ title: document.title, url: window.location.href })
      .then(response => console.log('response', response))
      .catch(err => console.err('error', err))
  }

  shareDesktop() {
    this.toggle()
  }

  toggle() {
    this.parent.classList.toggle('share-function--active')
  }

  copyToClipboard() {
    this.showSuccessfulCopyMessage()
  }

  showSuccessfulCopyMessage() {
    if (this.copyMessageTimeoutId) {
      clearTimeout(this.copyMessageTimeoutId)
    }

    this.copyMessage.classList.remove('share-function__message--inactive')
    this.copyMessageTimeoutId = setTimeout(this.hideSuccessfulCopyMessage.bind(this), 1500)
  }

  hideSuccessfulCopyMessage() {
    this.copyMessage.classList.add('share-function__message--inactive')
  }
}

export default ShareFunction
